module.exports = __webpack_public_path__ + "img/IMG_9000_L_Black_MockedUp.05fce66b.jpg";